import { render, staticRenderFns } from "./WelcomeNoCommunity.vue?vue&type=template&id=54028af8"
import script from "./WelcomeNoCommunity.vue?vue&type=script&lang=js"
export * from "./WelcomeNoCommunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports